import { useRef } from "react";
import { useHorizontalScroll } from "../../../Helpers/useSideScroll";
import { ListItemCard } from "./ListItemCard";

import "./ListGroupingSlider.css";

export const ListGroupingSlider = ({
	passSelectedService,
	selectedService,
	reservables
}) => {
	const widthCheck = useRef();
	const scrollRef = useHorizontalScroll();

	const handleClick = (entry) => {
		if (!entry) return; // Prevent unnecessary state updates
		passSelectedService(entry);
	};


	const fields = reservables.map((field, index) => (
		<ListItemCard
			isHighlighted={field.id === selectedService?.id}
			key={field.id}
			field={field}
			selected={selectedService?.id || 0}
			handleClick={handleClick}
			totalFields={reservables.length}
			isLast={index === reservables.length - 1}
		/>
	));

	return (
		<div className="list-fields-container-wrapper">
			<div
				className="list-fields-container"
				ref={(element) => {
					widthCheck.current = element;
					scrollRef.current = element; // Assign the same ref to scrollRef
				}}
			>
				{fields}
			</div>
		</div>
	);
};
